(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[80934],{

/***/ 48100:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packs",
      function () {
        return __webpack_require__(82021);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        root: (_obj = {
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: 70,
            padding: theme.spacing(4, 2),
            borderRadius: 6,
            background: theme.palette.primaryTransparent.light
        }, _defineProperty(_obj, theme.breakpoints.up('lg'), {
            flexDirection: 'row',
            justifyContent: 'space-between',
            textAlign: 'left',
            minHeight: 100,
            height: '100%',
            padding: theme.spacing(4, 4),
            borderRadius: theme.shape.borderRadius
        }), _defineProperty(_obj, '.MuiGrid-grid-md-4 &', {
            height: 'auto',
            padding: theme.spacing(1, 2),
            margin: theme.spacing(2, 0, 3)
        }), _obj),
        media: _defineProperty({
            margin: theme.spacing(0, 0, 2),
            '&>img': {
                display: 'block',
                maxWidth: 60
            }
        }, theme.breakpoints.up('lg'), {
            margin: 0,
            paddingRight: theme.spacing(5),
            '&>img': {
                maxWidth: 60
            }
        }),
        text: {
            flex: 1
        },
        richText: {
            '& p, & ul, & ol': {
                margin: 0
            },
            '& a': {
                color: 'currentColor',
                textDecoration: 'underline',
                '&:hover, &:focus': {
                    textDecoration: 'none'
                }
            }
        },
        rootCenter: _defineProperty({}, theme.breakpoints.up('lg'), {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
        }),
        mediaCenter: {
            margin: theme.spacing(0, 0, 2),
            paddingRight: 0
        },
        commitmentImage: {
            width: '60px'
        }
    });
});
var Commitment = function(props) {
    var classes = useStyles(props);
    var icon = props.icon, title = props.title, desc = props.desc, center = props.center;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: center ? "commitment ".concat(classes.rootCenter, " ").concat(classes.root) : "commitment ".concat(classes.root),
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: center ? "commitment__media ".concat(classes.mediaCenter, " ").concat(classes.media) : "commitment__media ".concat(classes.media),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: icon,
                    alt: "",
                    className: classes.commitmentImage
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "commitment__text ".concat(classes.text),
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "h3",
                        component: "p",
                        className: 'commitment__title',
                        children: title
                    }),
                    desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "body1",
                        component: "div",
                        className: "commitment__desc ".concat(classes.richText),
                        children: desc
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Commitment);


/***/ }),

/***/ 40984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ loadingDatas; },
/* harmony export */   "A": function() { return /* binding */ loadingPacksDatas; }
/* harmony export */ });
var loadingDatas = [
    {
        name: 'skeleton-1'
    },
    {
        name: 'skeleton-2'
    },
    {
        name: 'skeleton-3'
    },
    {
        name: 'skeleton-4'
    },
    {
        name: 'skeleton-5'
    },
    {
        name: 'skeleton-6'
    },
    {
        name: 'skeleton-7'
    },
    {
        name: 'skeleton-8'
    },
    {
        name: 'skeleton-9'
    },
    {
        name: 'skeleton-10'
    },
    {
        name: 'skeleton-11'
    },
    {
        name: 'skeleton-12'
    }, 
];
var loadingPacksDatas = [
    {
        name: 'skeleton-1'
    },
    {
        name: 'skeleton-2'
    },
    {
        name: 'skeleton-3'
    },
    {
        name: 'skeleton-4'
    }, 
];


/***/ }),

/***/ 82021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages_packs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./redux/actions/prismic.ts
var prismic = __webpack_require__(64063);
// EXTERNAL MODULE: ./components/Layout/Layout.tsx
var Layout = __webpack_require__(8122);
// EXTERNAL MODULE: ./components/Hero/HeroSection.tsx
var HeroSection = __webpack_require__(87170);
// EXTERNAL MODULE: ./components/Commitment/Commitment.tsx
var Commitment = __webpack_require__(88737);
// EXTERNAL MODULE: ./components/Shop/Shop.style.tsx
var Shop_style = __webpack_require__(45889);
// EXTERNAL MODULE: ./components/DateRangeForm/DateRangeForm.tsx + 1 modules
var DateRangeForm = __webpack_require__(4998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tabs/Tabs.js + 7 modules
var Tabs = __webpack_require__(57821);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(41423);
;// CONCATENATED MODULE: ./components/Shop/OutfitTab.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var OutfitTab = (0,withStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            padding: theme.spacing(0, 2),
            minWidth: 0,
            borderRadius: theme.shape.borderRadius * 3,
            minHeight: 32,
            textTransform: 'none',
            color: theme.palette.common.black,
            backgroundColor: theme.extraColors.greyLight,
            opacity: 1,
            '&+.MuiTab-root': {
                marginLeft: 10
            },
            '& .MuiButtonBase-root': {
                height: 32
            },
            '&:hover': {
                color: theme.palette.common.white,
                backgroundColor: theme.palette.primary.main
            },
            '&$selected': {
                color: theme.palette.common.white,
                backgroundColor: theme.palette.primary.main
            },
            '& > span': {
                flexDirection: 'row',
                '& > :first-child': {
                    marginBottom: '0 !important'
                }
            }
        },
        selected: {}
    });
})(function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Tab/* default */.Z, _objectSpread({}, props));
});
/* harmony default export */ var Shop_OutfitTab = (OutfitTab);

// EXTERNAL MODULE: ./components/Packs/PacksCard.tsx
var PacksCard = __webpack_require__(69036);
// EXTERNAL MODULE: ./components/Global/LoadingDatas.tsx
var LoadingDatas = __webpack_require__(40984);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
;// CONCATENATED MODULE: ./components/Packs/PacksTab.tsx

/* eslint-disable @typescript-eslint/no-unused-expressions */ 





var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            marginTop: theme.spacing(3)
        },
        skeletonCard: {
            padding: theme.spacing(0.5),
            boxShadow: theme.shadows[1],
            borderRadius: theme.shape.borderRadius
        },
        skeletonRow: {
            marginTop: theme.spacing(2)
        }
    });
});
var PacksTab = function(param) {
    var packs = param.packs, latestProducts = param.latestProducts, text = param.text, t = param.t, shopText = param.shopText, settings = param.settings, packPush = param.packPush, takeback = param.takeback;
    var ref;
    var classes = useStyles();
    var packLayout = settings === null || settings === void 0 ? void 0 : settings.pack_layout;
    var aspectRatio = (0,utils/* thumbnailRatio */.pm)(settings === null || settings === void 0 ? void 0 : settings.thumbnail_ratio);
    var cardWidth = settings === null || settings === void 0 ? void 0 : settings.medium_image_size;
    var thumbWidth = settings === null || settings === void 0 ? void 0 : settings.small_image_size;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classes.root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            spacing: 8,
            className: 'pack__grid',
            children: [
                packs && packs.loading === true && LoadingDatas/* loadingPacksDatas.map */.A.map(function(loadingPacksData) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.skeletonCard,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rect",
                                    width: '100%',
                                    height: 180
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rect",
                                    width: '100%',
                                    height: 60,
                                    className: classes.skeletonRow
                                })
                            ]
                        })
                    }, "item-".concat(loadingPacksData.name));
                }),
                packs && (packs === null || packs === void 0 ? void 0 : packs.items) && (packs === null || packs === void 0 ? void 0 : (ref = packs.items) === null || ref === void 0 ? void 0 : ref.map(function(pack, index) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(PacksCard/* default */.Z, {
                        latestProducts: latestProducts,
                        numberPack: packs.length,
                        pack: pack,
                        settings: settings,
                        t: t,
                        text: text,
                        shopText: shopText,
                        index: index,
                        thumbRatio: aspectRatio,
                        thumbWidth: thumbWidth,
                        cardWidth: cardWidth,
                        packLayout: packLayout,
                        packPush: packPush,
                        takeback: takeback
                    }, "".concat(pack.code, "-").concat(index)));
                }))
            ]
        })
    }));
};
/* harmony default export */ var Packs_PacksTab = (PacksTab);

// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./redux/actions/packs.ts + 1 modules
var packs = __webpack_require__(37876);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(56251);
// EXTERNAL MODULE: ./redux/actions/products.ts
var products = __webpack_require__(86730);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./utils/scrollState.tsx
var utils_scrollState = __webpack_require__(75216);
// EXTERNAL MODULE: ./utils/useSticky.tsx
var useSticky = __webpack_require__(31494);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
;// CONCATENATED MODULE: ./components/Packs/PacksCatalog.tsx


















function PacksCatalog_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PacksCatalog_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PacksCatalog_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PacksCatalog_useStyles = (0,makeStyles/* default */.Z)(function() {
    return (0,createStyles/* default */.Z)({
        root: {}
    });
});
var OutfitTabs = (0,withStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        root: (_obj = {
            borderBottom: 0,
            minHeight: 32
        }, PacksCatalog_defineProperty(_obj, theme.breakpoints.down('md'), {
            minWidth: '100%'
        }), PacksCatalog_defineProperty(_obj, '& .MuiTabScrollButton-root', {
            width: 32,
            '&.Mui-disabled': {
                opacity: 0.3
            }
        }), _obj),
        indicator: {
            backgroundColor: 'transparent'
        }
    };
})(Tabs/* default */.Z);
function a11yProps(index) {
    return {
        id: "outfit-tab-".concat(index),
        'aria-controls': "outfit-tabpanel-".concat(index)
    };
}
var mapStateToProps = function(state) {
    return {
        packs: state.packs,
        latestProducts: state.products.latestProducts,
        currentShopPage: state.products.items.page,
        productTaxons: state.taxons
    };
};
var mapDispatchToProps = {
    getPacksByPackTaxonId: packs/* getPacksByPackTaxonId */.M9,
    getLatestProducts: products/* getLatestProducts */.lO
};
var PacksCatalog = function(param1) {
    var taxonsPacks = param1.taxonsPacks, packs = param1.packs, getPacksByPackTaxonId1 = param1.getPacksByPackTaxonId, t = param1.t, shopText = param1.shopText, latestProducts = param1.latestProducts, currentShopPage = param1.currentShopPage, text = param1.text, settings = param1.settings, productTaxons = param1.productTaxons, getLatestProducts1 = param1.getLatestProducts, takeback = param1.takeback, selectedCategory = param1.selectedCategory, setSelectedCategories = param1.setSelectedCategories;
    var ref8, ref1, ref2, ref3;
    var classes = PacksCatalog_useStyles();
    var LayoutStyle = {};
    var shopClasses = (0,Shop_style/* default */.Z)(LayoutStyle);
    var router = (0,next_router.useRouter)();
    var cat = router === null || router === void 0 ? void 0 : (ref8 = router.query) === null || ref8 === void 0 ? void 0 : ref8.cat;
    var packPushs = text === null || text === void 0 ? void 0 : text.pushs;
    var ref4 = (0,react.useState)(), packPush = ref4[0], setPackPush = ref4[1];
    var ref5 = (0,useMatomo/* default */.Z)(), trackEvent = ref5.trackEvent, pushInstruction = ref5.pushInstruction;
    var scrollState = (0,utils_scrollState/* useScrollState */.M)();
    var isSticky = (0,useSticky/* useSticky */.A)(false);
    var handleChange = function(event, newValue) {
        var taxonCode = taxonsPacks[newValue].code;
        var taxonId = taxonsPacks[newValue].id;
        // Update query url to keep tracking history
        window.history.replaceState(PacksCatalog_objectSpread({}, window.history.state, {
            as: "/packs?cat=".concat(taxonCode),
            url: "/packs?cat=".concat(taxonCode)
        }), '', "?cat=".concat(taxonCode));
        router.push("?cat=".concat(taxonCode), undefined, {
            shallow: true
        });
        setSelectedCategories(newValue);
        trackEvent({
            category: 'Packs',
            action: "Change category",
            name: "".concat(taxonId)
        });
        pushInstruction('setEcommerceView', false, false, taxonId);
        pushInstruction('trackPageView', taxonId);
        // get Pack by taxon Id
        getPacksByPackTaxonId1(taxonId);
    };
    (0,react.useEffect)(function() {
        if (typeof taxonsPacks !== 'undefined' && taxonsPacks.length > 0 && typeof cat === 'undefined') {
            // get default packs with first taxon id
            var taxonId = taxonsPacks[0].id;
            getPacksByPackTaxonId1(taxonsPacks[0].id);
            pushInstruction('setEcommerceView', false, false, taxonId);
            pushInstruction('trackPageView', taxonId);
            // Look in Prismic Pack Push related category and set it
            var taxonCode = taxonsPacks[0].code;
            var taxonPush = packPushs === null || packPushs === void 0 ? void 0 : packPushs.filter(function(el) {
                var ref;
                return ((ref = el.taxon_pack_code[0]) === null || ref === void 0 ? void 0 : ref.text) === taxonCode;
            });
            setPackPush(taxonPush);
        } else if (typeof taxonsPacks !== 'undefined') {
            var ref9, ref6, ref7;
            var idCat = typeof cat !== 'undefined' ? (ref9 = taxonsPacks === null || taxonsPacks === void 0 ? void 0 : taxonsPacks.find(function(taxon) {
                return taxon.code === cat;
            })) === null || ref9 === void 0 ? void 0 : ref9.id : (ref6 = taxonsPacks[0]) === null || ref6 === void 0 ? void 0 : ref6.id;
            getPacksByPackTaxonId1(idCat);
            setSelectedCategories(taxonsPacks === null || taxonsPacks === void 0 ? void 0 : taxonsPacks.findIndex(function(taxon) {
                return taxon.code === cat;
            }));
            pushInstruction('setEcommerceView', false, false, idCat);
            pushInstruction('trackPageView', idCat);
            // Look in Prismic Pack Push related category and set it
            var taxonCode1 = (ref7 = taxonsPacks === null || taxonsPacks === void 0 ? void 0 : taxonsPacks.find(function(taxon) {
                return taxon.code === cat;
            })) === null || ref7 === void 0 ? void 0 : ref7.code;
            var taxonPush1 = packPushs === null || packPushs === void 0 ? void 0 : packPushs.filter(function(el) {
                var ref;
                return ((ref = el.taxon_pack_code[0]) === null || ref === void 0 ? void 0 : ref.text) === taxonCode1;
            });
            setPackPush(taxonPush1);
        }
    }, [
        taxonsPacks
    ]);
    (0,react.useEffect)(function() {
        getLatestProducts1();
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "catalog ".concat(classes.root),
        id: 'catalog',
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: 'spy'
            }),
            typeof taxonsPacks !== 'undefined' && taxonsPacks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)('sticky-bar', 'sticky-bar--pack', shopClasses.stickyBar, isSticky && [
                    shopClasses.stickyBarSticked,
                    'sticky-bar--sticked'
                ], scrollState.showOnTop && [
                    shopClasses.stickyBarTop,
                    'sticky-bar--top', 
                ], scrollState.showOnScrollUp && [
                    shopClasses.stickyBarScrollUp,
                    'sticky-bar--scrollup', 
                ]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "shop-menu shop-menu--pack ".concat(shopClasses.shopMenu),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "shop-menu__list ".concat(shopClasses.shopMenuList),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutfitTabs, {
                                variant: "scrollable",
                                scrollButtons: "auto",
                                value: selectedCategory,
                                onChange: handleChange,
                                "aria-label": "Outfits",
                                children: taxonsPacks.map(function(param, index) {
                                    var name = param.name;
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_OutfitTab, PacksCatalog_objectSpread({
                                        label: name
                                    }, a11yProps(index)), "tabpanel-".concat(index)));
                                })
                            })
                        }),
                        (0,CMSText/* isPrismicText */.LT)(text === null || text === void 0 ? void 0 : text.pack_to_shop_button) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "shop-menu__cta ".concat(shopClasses.shopMenuCta),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: currentShopPage !== 1 && (productTaxons === null || productTaxons === void 0 ? void 0 : (ref1 = productTaxons.items) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && localStorage.getItem('selectedCategory') !== null ? "/".concat((ref3 = (ref2 = productTaxons === null || productTaxons === void 0 ? void 0 : productTaxons.items[0]) === null || ref2 === void 0 ? void 0 : ref2.children[localStorage.getItem('selectedCategory')]) === null || ref3 === void 0 ? void 0 : ref3.slug, "?currentPage=").concat(currentShopPage) : '/shop',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "outlined",
                                        size: "small",
                                        component: "span",
                                        className: "shop-menu__cta-link",
                                        onClick: function() {
                                            return trackEvent({
                                                category: 'Packs',
                                                href: '/shop',
                                                action: "Pack to Shop"
                                            });
                                        },
                                        color: "primary",
                                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: text === null || text === void 0 ? void 0 : text.pack_to_shop_button,
                                            defaultText: t('texts:packs:pack_to_shop_button')
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                in: packs.loading === false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-packs": packs.loading === false ? 'loaded' : 'loading',
                    children: packs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Packs_PacksTab, {
                        latestProducts: latestProducts,
                        packs: packs,
                        t: t,
                        shopText: shopText,
                        text: text,
                        settings: settings,
                        packPush: packPush,
                        takeback: takeback
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Packs_PacksCatalog = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(PacksCatalog));

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
;// CONCATENATED MODULE: ./pages/packs.tsx

















var packs_mapStateToProps = function(state) {
    return {
        taxonPack: state.taxonPack,
        parameters: state.parameters,
        taxonsPacks: state.taxonPack.items
    };
};
var packs_mapDispatchToProps = {
    getPackTaxons: packs/* getPackTaxons */.Ht
};
var Packs = function(param) {
    var doc = param.doc, main = param.main, funnel = param.funnel, taxonPack = param.taxonPack, getPackTaxons1 = param.getPackTaxons, inStoreText = param.inStoreText, parameters = param.parameters, takeback = param.takeback, shopText = param.shopText, basket = param.basket, accountRes = param.accountRes, faqRes = param.faqRes, banner = param.banner, taxonsPacks = param.taxonsPacks;
    var ref23, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    var LayoutStyle = {};
    var classes = (0,Shop_style/* default */.Z)(LayoutStyle);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var trackPageView = (0,useMatomo/* default */.Z)().trackPageView;
    var isSubscription =  false || "date_to_date" === 'classic_subscription';
    var settings = main === null || main === void 0 ? void 0 : main.data;
    var isEnableChooseStartingDate = parameters === null || parameters === void 0 ? void 0 : (ref23 = parameters.items) === null || ref23 === void 0 ? void 0 : ref23.enableChooseStartingDate;
    var cat = router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.cat;
    var ref21 = (0,react.useState)(typeof cat !== 'undefined' && typeof taxonsPacks !== 'undefined' ? taxonsPacks === null || taxonsPacks === void 0 ? void 0 : taxonsPacks.findIndex(function(taxon) {
        return taxon.code === cat;
    }) : 0), selectedCategory = ref21[0], setSelectedCategories = ref21[1];
    var taxonPackImage = (0,react.useMemo)(function() {
        var ref, ref22;
        return taxonsPacks === null || taxonsPacks === void 0 ? void 0 : (ref = taxonsPacks[selectedCategory]) === null || ref === void 0 ? void 0 : (ref22 = ref.images) === null || ref22 === void 0 ? void 0 : ref22[0];
    }, [
        selectedCategory,
        taxonsPacks
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,prismic/* SAVE_PRISMIC_DOCUMENTS */.w)({
            general: main === null || main === void 0 ? void 0 : main.data,
            funnel: funnel === null || funnel === void 0 ? void 0 : funnel.data,
            instore: inStoreText === null || inStoreText === void 0 ? void 0 : inStoreText.data
        }));
    }, [
        main,
        funnel,
        inStoreText
    ]);
    (0,react.useEffect)(function() {
        trackPageView({
            documentTitle: 'Packs'
        });
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        if ((main === null || main === void 0 ? void 0 : (ref = main.data) === null || ref === void 0 ? void 0 : ref.pack_page) === false) {
            router.push('/shop');
        }
        if (typeof taxonsPacks === 'undefined') {
            getPackTaxons1();
        }
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        mainLogo: main === null || main === void 0 ? void 0 : (ref2 = main.data) === null || ref2 === void 0 ? void 0 : ref2.logo,
        doc: main,
        t: t,
        inStoreText: inStoreText,
        metaTitle: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.meta_title_packs, t('texts:general:herotitle')),
        metaDescription: doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.meta_description_packs,
        metaKeywords: doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : ref5.meta_keywords_packs,
        basket: basket,
        takeback: takeback,
        account: accountRes,
        faq: faqRes,
        banner: banner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            className: "main main--pack ".concat(classes.root),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection/* default */.Z, {
                    title: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.herotitle, t('texts:general:herotitle')),
                    isMainTitle: true,
                    topTitle: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.hero_top_title),
                    heroImg: main === null || main === void 0 ? void 0 : (ref8 = main.data) === null || ref8 === void 0 ? void 0 : ref8.hero_banner,
                    heroSettings: main === null || main === void 0 ? void 0 : main.data,
                    taxonImg: taxonPackImage
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: (0,clsx_m/* default */.Z)('shop__content', classes.shopContent),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        maxWidth: "xl",
                        className: classes.shopContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)('shop__planner', classes.shopPlanner, !isSubscription && classes.shopPlannerDad, isSubscription && classes.noBoxShadow),
                                children: !isSubscription || isEnableChooseStartingDate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangeForm/* default */.Z, {
                                    text: main === null || main === void 0 ? void 0 : main.data,
                                    textFunnel: funnel === null || funnel === void 0 ? void 0 : funnel.data,
                                    t: t,
                                    parameters: parameters,
                                    scrollTarget: 'catalog'
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: (doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.has_shipping_card) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                        container: true,
                                        spacing: 9,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                item: true,
                                                sm: 12,
                                                md: 6,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        component: "p",
                                                        variant: "h3",
                                                        children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : ref10.titlepacks, t('texts:packs:titlepacks'))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        component: "div",
                                                        variant: "body1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            data: doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.packsparagraph,
                                                            defaultText: t('texts:packs:packsparagraph')
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                item: true,
                                                sm: 12,
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Commitment/* default */.Z, {
                                                    icon: (doc === null || doc === void 0 ? void 0 : (ref12 = doc.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.image_shipping_section) === null || ref13 === void 0 ? void 0 : ref13.url) ? doc.data.image_shipping_section.url : null,
                                                    desc: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        data: doc === null || doc === void 0 ? void 0 : (ref14 = doc.data) === null || ref14 === void 0 ? void 0 : ref14.shipping_description,
                                                        defaultText: t('texts:packs:shipping_description')
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                maxWidth: "xl",
                                className: classes.shopArea,
                                children: [
                                    !isSubscription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classes.shopIntro,
                                        children: (doc === null || doc === void 0 ? void 0 : (ref15 = doc.data) === null || ref15 === void 0 ? void 0 : ref15.has_shipping_card) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            container: true,
                                            spacing: 9,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    item: true,
                                                    sm: 12,
                                                    md: 6,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            component: "p",
                                                            variant: "h3",
                                                            children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref16 = doc.data) === null || ref16 === void 0 ? void 0 : ref16.titlepacks, t('texts:packs:titlepacks'))
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            component: "p",
                                                            variant: "body1",
                                                            children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref17 = doc.data) === null || ref17 === void 0 ? void 0 : ref17.packsparagraph, t('texts:packs:packsparagraph'))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    sm: 12,
                                                    md: 6,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Commitment/* default */.Z, {
                                                        icon: (doc === null || doc === void 0 ? void 0 : (ref18 = doc.data) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.image_shipping_section) === null || ref19 === void 0 ? void 0 : ref19.url) ? doc.data.image_shipping_section.url : null,
                                                        desc: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            data: doc === null || doc === void 0 ? void 0 : (ref20 = doc.data) === null || ref20 === void 0 ? void 0 : ref20.shipping_description,
                                                            defaultText: t('texts:packs:shipping_description')
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Packs_PacksCatalog, {
                                        t: t,
                                        shopText: shopText,
                                        taxonsPacks: taxonsPacks,
                                        text: doc === null || doc === void 0 ? void 0 : doc.data,
                                        settings: settings,
                                        takeback: takeback,
                                        selectedCategory: selectedCategory,
                                        setSelectedCategories: setSelectedCategories
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ var pages_packs = ((0,es/* connect */.$j)(packs_mapStateToProps, packs_mapDispatchToProps)(Packs));


/***/ }),

/***/ 31494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useSticky; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8920);


var useSticky = function(layout) {
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isSticky = ref[0], setIsSticky = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var isMounted = true;
        var observer;
        var handleSticky = function() {
            if ( true && !layout && isMounted) {
                var spyEl = document.querySelector('.spy');
                var handler = function(entries) {
                    if (!entries[0].isIntersecting) {
                        setIsSticky(true);
                    } else {
                        setIsSticky(false);
                    }
                };
                var observeOpts = {
                    rootMargin: "-".concat(theme.spacing(4), "px 0px 0px 0px"),
                    threshold: 0.5
                };
                // create the observer
                observer = new IntersectionObserver(handler, observeOpts);
                observer.observe(spyEl);
            }
        };
        handleSticky();
        return function() {
            isMounted = false;
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [
        "object",
        layout
    ]);
    return isSticky;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [282,2215,15350,79593,68480,1111,57443,94108,74805,76142,75436,84997,50273,230,19789,29705,79956,17012,18496,4998,31474,49774,92888,40179], function() { return __webpack_exec__(48100); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);